export const BASE_PATH = {
  default: {
    preferenceSearch: '/atendimento-agendado/preferencia',
    professionalSearch: '/atendimento-agendado/preferencia/busca-profissional',
    professionalSearchCRPV2:
      '/atendimento-agendado-psicologo/busca-profissional/v2',
    preferenceTimeSlot: '/atendimento-agendado/especialidade/busca',
    fullProfileCRP: '/atendimento-agendado-psicologo/perfil',
    category: '/atendimento-agendado/categoria',
    oldProfileCRP: '/atendimento-agendado/categoria/PSICOLOGO',
    screeningFlow: '/atendimento-agendado-psicologo/busca-profissional',
  },
  newSchedule: {
    professionalSearch: '/atendimento-agendado/busca-profissional-agenda',
    category: '/atendimento-agendado/categoria/busca',
  },
}
